import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <span className="footer-logo">KeepOrDel</span>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="sep">·</span>
          <Link to="/terms">Terms & Conditions</Link>
          <span className="sep">·</span>
          <a href="mailto:baralnishan987@gmail.com">Contact</a>
        </div>
        <p className="footer-copy">© {year} Nishan Baral. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
